import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d9308c6")

_pushScopeId("data-v-1d9308c6")
const _hoisted_1 = { class: "cce-panel-wrap flex-column ue-wrap rel" }
const _hoisted_2 = { style: {"margin-bottom":"53px"} }
const _hoisted_3 = { class: "flex justify-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "添加结束条件", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下一步")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_step = _resolveComponent("a-step")
  const _component_a_steps = _resolveComponent("a-steps")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_textarea = _resolveComponent("a-textarea")
  const _component_UploadImg = _resolveComponent("UploadImg")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_Col = _resolveComponent("Col")
  const _component_a_time_picker = _resolveComponent("a-time-picker")
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")
  const _component_Row = _resolveComponent("Row")
  const _component_DownOutlined = _resolveComponent("DownOutlined")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_spin = _resolveComponent("a-spin")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      spinning: _ctx.unitExperiment.editing.value||_ctx.unitExperiment.quering.value
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_a_steps, {
            current: _ctx.unitExperiment.currentStep.value,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unitExperimentController.handleStepChange($event))),
            size: "small",
            slot: "progressDot",
            "slot-scope": "{index,title}",
            labelPlacement: "vertical"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.basicInfo.selectedUnits.value, (caseUnit, caseUnitIndex) => {
                return (_openBlock(), _createBlock(_component_a_step, {
                  key: caseUnit,
                  title: caseUnit
                }, null, 8, ["title"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["current"])
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_a_form, {
            style: {"width":"577px"},
            "label-col": _ctx.labelCol,
            "wrapper-col": _ctx.wrapperCol
          }, {
            default: _withId(() => [
              _createVNode(_component_a_form_item, { label: "单元任务目标" }, {
                default: _withId(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.unitExperiment.formState.unitTaskTarget,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.unitExperiment.formState.unitTaskTarget = $event)),
                    maxlength: 300
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元任务描述" }, {
                default: _withId(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.unitExperiment.formState.unitTaskDescription,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.unitExperiment.formState.unitTaskDescription = $event)),
                    maxlength: 2000
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元实验目的" }, {
                default: _withId(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.unitExperiment.formState.unitExperimentObjective,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.unitExperiment.formState.unitExperimentObjective = $event)),
                    maxlength: 2000
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元准备知识" }, {
                default: _withId(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.unitExperiment.formState.unitReadyKnowledge,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.unitExperiment.formState.unitReadyKnowledge = $event)),
                    maxlength: 2000
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元准备描述" }, {
                default: _withId(() => [
                  _createVNode(_component_a_textarea, {
                    value: _ctx.unitExperiment.formState.unitDescription,
                    "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.unitExperiment.formState.unitDescription = $event)),
                    maxlength: 2000
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元实验流程" }, {
                default: _withId(() => [
                  _createVNode(_component_UploadImg, {
                    urlsrc: _ctx.unitExperiment.formState.unitImg,
                    onUpload: _cache[7] || (_cache[7] = ($event: any) => (_ctx.unitExperimentController.handleImgUpload($event))),
                    text: "210x118",
                    aspectRatio: NaN
                  }, null, 8, ["urlsrc"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元实验计时方式" }, {
                default: _withId(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.unitExperiment.formState.unitTimeMode,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (_ctx.unitExperiment.formState.unitTimeMode = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.UnitTimeModes, (mode, modeIndex) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, { value: modeIndex }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(mode), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 256))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元实验结束条件" }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.unitExperiment.formState.unitEndConditionList, (condition, conditionIndex) => {
                    return (_openBlock(), _createBlock(_component_Row, {
                      class: "rel",
                      style: {"margin-bottom":"34px"},
                      key: condition.uid
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_Col, {
                          span: condition.endConditionType===0?16:24
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_a_select, {
                              value: condition.endConditionType,
                              "onUpdate:value": ($event: any) => (condition.endConditionType = $event)
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.EndConditionType, (endConditionType, endConditionTypeIndex) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    value: endConditionTypeIndex,
                                    key: endConditionType,
                                    disabled: endConditionTypeIndex===0 && _ctx.unitExperiment.timeConditionSelected.value
                                  }, {
                                    default: _withId(() => [
                                      _createTextVNode(_toDisplayString(endConditionType), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value", "disabled"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value"])
                          ]),
                          _: 2
                        }, 1032, ["span"]),
                        (condition.endConditionType===0)
                          ? (_openBlock(), _createBlock(_component_Col, {
                              key: 0,
                              span: 5,
                              style: {"margin-left":"24px"}
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_a_time_picker, {
                                  value: condition.endTime,
                                  "onUpdate:value": ($event: any) => (condition.endTime = $event),
                                  format: "HH:mm"
                                }, null, 8, ["value", "onUpdate:value"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (_ctx.unitExperiment.formState.unitEndConditionList.length>1)
                          ? (_openBlock(), _createBlock(_component_MinusCircleOutlined, {
                              key: 1,
                              class: "ue-del-btn",
                              onClick: ($event: any) => (_ctx.unitExperimentController.delUnitEndCondition(conditionIndex))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  _createVNode(_component_Row, null, {
                    default: _withId(() => [
                      _createVNode(_component_Col, { span: 24 }, {
                        default: _withId(() => [
                          _createVNode(_component_a_button, {
                            block: "",
                            type: 'dashed',
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.unitExperimentController.handleEndConditionAdd()))
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_DownOutlined),
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "单元实验提示" }, {
                default: _withId(() => [
                  _createVNode(_component_Row, { style: {"margin-bottom":"29px"} }, {
                    default: _withId(() => [
                      _createVNode(_component_Col, { span: 24 }, {
                        default: _withId(() => [
                          _createVNode(_component_a_textarea, {
                            value: _ctx.unitExperiment.formState.endInfo,
                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (_ctx.unitExperiment.formState.endInfo = $event)),
                            maxlength: 300
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("div", null, [
                    _createVNode(_component_a_button, {
                      class: "mr18",
                      type: 'primary',
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.unitExperimentController.handleSave())),
                      loading: _ctx.unitExperiment.editing.value
                    }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_a_button, {
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.unitExperimentController.handleNext()))
                    }, {
                      default: _withId(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label-col", "wrapper-col"])
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
})